var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-stun-servers"},[_c('div',{staticClass:"stun-servers ma-2"},[_c('stun-servers')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }